export default "__VITE_ASSET__3dabbb1e__"